import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CheckCircle from '@mui/icons-material/CheckCircle'
import React from 'react'
import { Component } from 'react'
import { urls } from './constants'
import { Eye, Eyeselect, Dropdown } from './svg'
import { connect } from 'react-redux';
import { backgroundColor, colors, debounce, focusElemnt, isEmpty, isNonEmpty } from './helper'
import { getBookingInfo,getPartyBookingInfo } from '../../store/common/common_action'

class LineInputV2 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isFocus: false,
      isBlur: true,
      inpval: '',
      hidepwd: true,
      mobileno: '',
      stateValue: props.value,
      max: props.maxLength || 100,
      color: props.color || false,
      suggestions: [],
      opensuggestions: false,
      cursor: 0,
      suggestionTaken:false,
    }
    this.ref = React.createRef()
    this.inputRef = React.createRef()
    this.searchResultRef = React.createRef()
  }
  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ stateValue: props.value, max: props.maxLength || 100 })
  }



  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.cursor < 0 ||
      this.state.cursor > this.state.suggestions.length ||
      !this.searchResultRef
    ) {
      return;
    }
  
    if (
      this.searchResultRef &&
      this.searchResultRef.current &&
      this.searchResultRef.current.children
    ) {
      let listItems = Array.from(this.searchResultRef.current.children);
      
      if (listItems[this.state.cursor]) {
        this.scrollIntoView(listItems[this.state.cursor].offsetTop);
      }
    }
  }
  

  handleOutsideClick = (event) => {
    if (this.inputRef.current && !this.inputRef.current.contains(event.target)) {
      this.setState({ opensuggestions: false }); // Close the suggestions dropdown
    }
  };
  showIcon = () => {
    if (this.state.hidepwd) {
      return <Eyeselect />
    } else {
      return <Eye />
    }
  }
  scrollIntoView = (position) => {
    this.searchResultRef.current.parentNode.scrollTo({
      top: position,
      behavior: 'smooth',
    })
  }

  renderSuggestions = () => {
    const { suggestions } = this.state;
    const { suggestKey } = this.props;
    if (!suggestions || suggestions.length === 0) return null;

    return (
      <div className="drop-Inp-wrapper">
        <div className="drop--content scroll" style={{width:'100%'}}>
          <ul className="list-group" ref={this.searchResultRef}>
            {suggestions.map((item, index) => (
              <li className={`drop--item ${this.state.cursor === index ? 'highlighted' : ''}`} id={`drop--item_${index}`} key={`drop--item_${index}`}
                onMouseDown={(e) => {
                  e.preventDefault()
                  this.props.handleSuggest && this.props.handleSuggest(e, item)
                  this.setState({
                    opensuggestions: false,
                    suggestionTaken: true,
                  })
                  this.onBlur(e)
                }}
              >
                <div>{item?.[suggestKey]}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };
  toglePwd = () => {
    this.ref.current.type = this.ref.current.type === 'password' ? 'text' : 'password'
    this.setState({ hidepwd: !this.state.hidepwd })
  }

  handleChange = (e) => {
    let value = e.target.value
    if (this.props.filter) value = this.props.filter(value)
    if (this.props.upperCase && typeof value === 'string') value = value.toUpperCase()

    if (value.length <= this.state.max && !this.props.disabled) {
      this.setState({ stateValue: value });
    }
    if ((value + '').length <= this.state.max && !this.props.disabled) {
      if (this.props.isSuggestion && value.length <= this.state.max && !this.props.disabled) {
        if (value.length > 2) {
          this.fetchSuggestions(value,this.props.isSuggestion);
        }
        else {
          this.setState({ suggestions: [], stateValue: value, opensuggestions: false });
        }
      } else {
        if ((value + '').length <= this.state.max && !this.props.disabled) {
          this.setState({
            suggestions: [],
            stateValue: value,
          });
        }
      }
    }
  }

  fetchSuggestions = debounce(async (value,suggestionType) => {
    try {
      let response;
      if(suggestionType===1){
        response= await this.props.getBookingInfo({ MobileNo: value })
      }
      if(suggestionType===3){
        response= await this.props.getBookingInfo({ UserName: value,Mode:1 })
      }
      if(suggestionType===2){
        const intCompanyID = this?.props?.stateData?.common?.loginData?.intCompanyID||0
        response =  await this.props.getPartyBookingInfo({CompanyID:intCompanyID,MobileNo: value})
      }
      if (response?.status === 'Success') {
        this.setState({
          suggestions: response.Data.Table,
          opensuggestions: value.length > 0 && response?.Data?.Table?.length > 0,
          cursor: 0,
        })
      }
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    }
  }, 1000);

  resetItem = () => {
    this.props.resetCallback && this.props.resetCallback()
    this.setState({ stateValue: '' })
  }
  handleFocus = (e) => {
    this.setState({suggestionTaken:false})
    this.props.onFocusExtra && this.props.onFocusExtra(e)
    if (this.props.disabled) {
      if (!this.props.onFocusExtra) {
        e.key = 'Enter'
        this.props.onKeyDown && this.props.onKeyDown(e)
      }
    } else {
      this.setState({ isFocus: true, isBlur: false })
      this.props.onFocus && this.props.onFocus(e)
    }
  }
  handleKeyDown = (e) => {
    if (this.props?.typeAs === 'number') {
      let value = this.state.stateValue
      if (this.props.filter) value = this.props.filter(this.state.stateValue)
      if (e.key === 'ArrowDown') {
        e.preventDefault()
        this.setState({ stateValue: Math.max(value - 1, 0) })
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault()
        this.setState({ stateValue: value + 1 })
      }
    }
  }
  onBlur = (e) => {
    this.setState({ isFocus: false, isBlur: true, opensuggestions: false })
    if (this.props.isSuggestion) {
      setTimeout(() => {
        this.props.onBlur && this.props.onBlur({ ...e, target: { ...e.target, value: this.state.stateValue } })
        if (!this.state.suggestionTaken) {
        }
      }, 100)
    } else {
      this.props.onBlur&& !this.props.disabled && this.props.onBlur(e)
    }
  }

  render() {
    const typeid = this?.props?.stateData?.common?.deliveybktId || this?.props?.stateData?.common?.selBookingType?.typeId
    return (
      <div className="input--content" ref={this.inputRef}>
        <input
          ref={this.ref}
          key={this.props.name}
          className={this.props.disabled ? 'disable' : ''}
          style={{ backgroundColor: this.props.disabled === false && this.state.color === true ? colors[typeid - 1] : '' }}
          type={this.props.type}
          id={this.props.id}
          name={this.props.name}
          value={this.state.stateValue}
          onFocus={this.handleFocus}
          onBlur={this.onBlur}
          onMouseDown={this.props.onMouseDown}
          onKeyPress={(e) => {
            this.props.onKeyPress && this.props.onKeyPress(e)
          }}
          onKeyDown={(e) => {
            if ((e.key === 'Enter' || e.key === 'Escape') && !this.props.isSuggestion) {
              this.setState({ isFocus: false, isBlur: true })
              this.props.onBlur && this.props.onBlur(e)
            }
            if (e.key === 'Enter' && this.props.isSuggestion && this.state.cursor !== -1 && this.state.suggestions.length) {
              this.props.handleSuggest && this.props.handleSuggest(e, this.state.suggestions[this.state.cursor])
              this.setState({
                opensuggestions: false,
                suggestionTaken: true,
              })
            }
            this.props.onKeyDown && this.props.onKeyDown(e)
            if (e.key === 'ArrowDown' && this.props.isSuggestion && this.state.opensuggestions) {
              focusElemnt(this.state.cursor + 1 === this.state.suggestions?.length ? this.props.id : `drop--item_${this.state.cursor + 1}`)
              this.setState({ cursor: this.state.cursor + 1 === this.state.suggestions?.length ? -1 : this.state.cursor + 1 })
            }
            if (e.key === 'ArrowUp' && this.props.isSuggestion && this.state.opensuggestions) {
              focusElemnt(this.state.cursor === 0 ? this.props.id : `drop--item_${this.state.cursor - 1}`)
              this.setState({ cursor: this.state.cursor === 0 ? -1 : this.state.cursor - 1 })
            }
            this.handleKeyDown(e)
          }}
          onChange={(e) => this.handleChange(e)}
          autoComplete="off"
          autoFocus={this.props.autoFocus}
          maxLength={this.props.maxLength}
          onClick={(e) => {
            this.props.onClick && this.props.onClick(e)
          }}
        />
        <div
          className={
            this.state.isFocus
              ? 'input--label active'
              : (this.props.value + '').length > 0 && this.state.isBlur
              ? ' input--label filled'
              : 'input--label'
          }
        >
          {this.props.label}
        </div>
        {this.props.icon === 'pwd' && (
          <div className="icon" onClick={this.toglePwd}>
            {this.showIcon()}
          </div>
        )}
        {/* {this.props.icon === 'chkcirle' && this.props.value.length > 0 && !this.state.isFocus && (
          <div className="icon --chkcirle">{<CheckCircle sx={{ color: '#14c508b0', fontSize: 26 }} />}</div>
        )} */}
        {this.props.icon === 'crossIcon' && isNonEmpty(this.state.stateValue) && (
          <div className="cross--icon" onClick={this.resetItem} id={this.props.crossIconId}>
            <span className="cross">
              <FontAwesomeIcon icon={faXmark} color={'#777'} />
            </span>
          </div>
        )}
        {this.props.icon === 'chkActionGST' && this.props.value.length > 0 && (
          <div className="icon --chkBtn">
            {
              <span
                style={{ color: '#0086ff', textDecoration: 'underline', fontWeight: 'bold' }}
                onClick={() => {
                  window.open(urls.searchTaxPayer)
                }}
              >
                Check
              </span>
            }
          </div>
        )}
        {this.props.icon === 'drop' && (
          <div className="icon--drop">
            <Dropdown />
          </div>
        )}
        {this.props.isSuggestion && this.state.opensuggestions && this.state.isFocus ? this.renderSuggestions() : null}
      </div>
    )
  }
}
const mapStateToProps = (stateData) => ({ stateData })
const mapDispatchToProps = {
  getBookingInfo,
  getPartyBookingInfo
}
export default connect(mapStateToProps, mapDispatchToProps)(LineInputV2)
// export default LineInputV2
